import { motion } from "framer-motion";

export default function Navbar() {
  return (
    <motion.header
      className="fixed inset-x-0 top-0 z-[80] border-b border-ink/15 bg-bone/90 backdrop-blur-md"
      initial={{ y: "-100%" }}
      animate={{ y: 0 }}
      transition={{ delay: 2.6, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3">
          <img
            src="/assets/wmwe-logo-dark.png"
            alt="WMWE logo"
            className="h-9 w-9 rounded-full border border-ink/15 bg-cream object-contain p-[3px]"
          />
          <span className="font-sans text-[11px] tracking-[0.35em] text-ink">
            RECON 2026 <span className="text-ink/40">// THE BRIEFING</span>
          </span>
        </a>
        <div className="flex items-center gap-6">
          <span className="hidden font-sans text-[10px] tracking-[0.3em] text-ink/50 md:block">
            NOV 13–14 // CHARLOTTE, NC
          </span>
          <a
            href="/checkout"
            data-testid="nav-cta-button"
            className="group relative overflow-hidden bg-wine px-5 py-2 font-sans text-[10px] tracking-[0.3em] text-bone"
          >
            <span className="absolute inset-0 translate-y-full bg-navy transition-transform duration-300 ease-out group-hover:translate-y-0" />
            <span className="relative">GET BRIEFED</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
}
